import {useEffect} from 'react'
import {GeoSearchControl, OpenStreetMapProvider} from "leaflet-geosearch";
import {useMap} from "react-leaflet";

import "leaflet-geosearch/dist/geosearch.css";

import {useTranslation} from 'react-i18next'
import {NOMINATIM_API_URL} from "@constants/config";
import {parseCoordinates} from "@ui/leafletCustom/mapSearch/helpers/parseCoordinates";

/**
 * Wraps the address provider so a pasted pair of coordinates - or a Google Maps link - resolves
 * to that exact spot instead of being sent to the geocoder, which would find nothing.
 * The result keeps the shape the control and the 'geosearch/showlocation' listeners expect.
 */
const buildProvider = () => {
    const addressProvider = new OpenStreetMapProvider({
        searchUrl: `${NOMINATIM_API_URL}/search.php`
    })

    return {
        search: async ({query}) => {
            const coordinates = parseCoordinates(query)

            if (!coordinates) {
                return addressProvider.search({query})
            }

            const label = `${coordinates.lat}, ${coordinates.lng}`

            return [{
                x: coordinates.lng,
                y: coordinates.lat,
                label,
                bounds: null,
                raw: {
                    lat: coordinates.lat,
                    lon: coordinates.lng,
                    display_name: label,
                },
            }]
        }
    }
}

const SearchControl = () => {
    const map = useMap();
    const {t} = useTranslation()

    useEffect(() => {
        const searchControl = new GeoSearchControl({
            provider: buildProvider(),
            style: undefined,
            showMarker: false,
            showPopup: false,
            autoClose: false,
            retainZoomLevel: false,
            animateZoom: true,
            keepResult: false,
            searchLabel: t('base.searchByAddressOrCoordinates'),
        });

        map.addControl(searchControl);
        return () => map.removeControl(searchControl);
    }, []);

    return null;
};


export default SearchControl;
